import { render, staticRenderFns } from "./yaozhui-yatongdian-right.vue?vue&type=template&id=80a1d2f0&scoped=true&"
import script from "./yaozhui-yatongdian-right.vue?vue&type=script&lang=ts&"
export * from "./yaozhui-yatongdian-right.vue?vue&type=script&lang=ts&"
import style0 from "./yaozhui-yatongdian-right.vue?vue&type=style&index=0&id=80a1d2f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a1d2f0",
  null
  
)

export default component.exports